/**
 * Centralized site configuration for SEO and domain management
 * Change baseUrl when connecting the final domain
 */

export const siteConfig = {
  // Development: Lovable domain, Production: https://www.fake-id.com
  baseUrl: 'https://www.fake-id.com',
  
  // Site identity
  name: 'Fake-ID.com',
  tagline: 'Premium Novelty ID Cards',
  description: 'Create stunning novelty ID cards with premium templates. High-quality custom designs with authentic-looking holograms and scannable barcodes.',
  
  // Contact
  email: 'info@fake-id.de',
  
  // Founding
  foundingYear: 2007,
  
  // Stats
  customerCount: '63,000+',
  reviewCount: 1500,
  averageRating: 4.9,
  
  // Social
  social: {
    // Add social links when available
  },
  
  // Languages
  defaultLanguage: 'en' as const,
  supportedLanguages: ['en', 'de', 'es', 'fr', 'pt', 'ru', 'it', 'sv', 'zh'] as const,
  
  // OG Image
  ogImage: '/og-image.jpg',
  
  // Currency
  defaultCurrency: 'EUR',
} as const;

export type SupportedLanguage = typeof siteConfig.supportedLanguages[number];

/**
 * Get the full URL for a path
 */
export function getFullUrl(path: string = ''): string {
  const base = siteConfig.baseUrl.replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${cleanPath}`;
}

/**
 * Get localized URL for a path
 */
export function getLocalizedUrl(path: string, language: SupportedLanguage): string {
  const base = siteConfig.baseUrl.replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  if (language === siteConfig.defaultLanguage) {
    return `${base}/${cleanPath}`;
  }
  
  return `${base}/${language}/${cleanPath}`;
}
